/* eslint-disable camelcase */
import React from 'react';
import { withCampaigns, CAMPAIGN_STATUS } from '@domain/campaigns';
import { Cell } from '@shared/components/tables/column-components/table.types';
import { SwitchButton } from '@paretogroup/tess';
import { APPCUES_ID } from './campaign-table-status-switch.constants';
import { TooltipSwitch } from './tooltip-switch';
import { CampaignRow } from '../../campaign-table.types';

interface CampaignStatusSwitchButtonImpl {
    cell: Cell<CampaignRow>,
    editCampaignReportsStats: Function,
}

const CampaignStatusSwitchButtonImpl = ({
    cell,
    editCampaignReportsStats,
}: CampaignStatusSwitchButtonImpl) => {
    const { row } = cell;
    const { original } = row;
    const {
        account_id: accountId,
        platform,
        level,
        campaign_id: campaignId,
        sublevel_id: subLevelId,
        status,
    } = original;

    const statusToBeChecked = ['enabled'];

    const isRemoved = status === CAMPAIGN_STATUS.REMOVED;

    return isRemoved
        ? <TooltipSwitch />
        : (
            <SwitchButton
                data-appcues-id={APPCUES_ID.SWITCH_BUTTON}
                checked={statusToBeChecked.includes(status)}
                disable={isEnded(status)}
                onChange={() => editCampaignReportsStats({
                    accountId,
                    platform,
                    level,
                    campaignId,
                    subLevelId,
                    field: 'status',
                    fieldValue: status,
                    originalValue: status,
                })}
            />
        );
};

const isEnded = (status : String) => status === CAMPAIGN_STATUS.ENDED;

export const CampaignStatusSwitchButton = withCampaigns(CampaignStatusSwitchButtonImpl);
